import React, { KeyboardEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import IMediaItem from '../../../interfaces/umbracoNodes/mediaItem';
import SVG from '../../rawSVG';

const LinkWithIconWrapper = styled.a`
	display: inline-flex;
	align-items: center;
	color: ${theme.colorsV2.mainDark};
	font-size: 18px;
	line-height: 1.4;
	transition: color 200ms ease;
	text-decoration: none;
	cursor: pointer;

	svg {
		margin-right: 8px;
		path {
			stroke: ${theme.colorsV2.mainDark};
			transition: stroke 200ms ease;
		}
	}

	&:active {
		color: ${theme.colorsV2.mainRed};
	}

	${media.desktopSmall`
		&:hover {
            color: ${theme.colorsV2.mainRed};
            svg path {
                stroke: ${theme.colorsV2.mainRed};
            }
		}
	`}
`;

type TProps = {
	children?: ReactNode;
	className?: string;
	href: string;
	icon?: IMediaItem;
	role?: string;
	tabIndex?: number;
	target?: string | null;
	title: string;
	onKeyDown?: (event: KeyboardEvent) => void;
};

export const LinkWithIcon = ({ children, className, href, icon, role, tabIndex, target, title, onKeyDown }: TProps) => {
	return (
		<LinkWithIconWrapper
			{...(!href.startsWith('http') &&
				(!href.endsWith('pdf') || !href.endsWith('exe') || !href.endsWith('zip')) && { as: Link, to: href })}
			{...((href.startsWith('http') || href.endsWith('pdf') || href.endsWith('exe') || href.endsWith('zip')) && {
				href: href,
				target: target,
			})}
			aria-label={title}
			className={className}
			rel="noreferrer"
			role={role}
			tabIndex={tabIndex}
			onKeyDown={onKeyDown}>
			{icon && <SVG src={icon.Src} width={24} height={24} title={icon.Name} />}
			{children}
			{title}
		</LinkWithIconWrapper>
	);
};

LinkWithIcon.defaultProps = {
	children: null,
	className: '',
	icon: undefined,
	role: '',
	tabIndex: 0,
	target: '_self',
	onKeyDown: undefined,
};
